import { ProDescriptions } from "@ant-design/pro-components";
import { Link } from "react-router-dom";
import { BasicTable, CustomDetailPage } from "@/components";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import {
  PageEnum,
  BUILDING_LIFT_TABLE_HEADER,
  COL1,
  COL2,
} from "@/enums/pageEnum";
import { LiftColumns } from "@/utils/commonConfig";

export default function BuildingDetailPage() {
  const BUILDIN = "#BUILDINGINFO";
  const { t } = useTranslation();
  const columns = useMemo(() => {
    return [
      { title: t("building"), dataIndex: "name", ...COL1 },
      { title: t("address"), dataIndex: "address", ...COL2 },
      { title: t("esManagCompany"), dataIndex: "estateMgmtCo", ...COL1 },
      { title: t("TOWN_COUNCIL"), dataIndex: "tc" },
      { title: t("blockNo"), dataIndex: "blk" },
      { title: t("pumpMCO"), dataIndex: "pumpMCO" },
      { title: t("postalCode"), dataIndex: "postalCode" },
      { title: t("streetCode"), dataIndex: "streetCode" },
      { title: t("branchOffice"), dataIndex: "branchOffice" },
      { title: t("issInstalledDate"), dataIndex: "issInstalledDate" },
      { title: t("cdc"), dataIndex: "cdc" },
      { title: t("activity"), dataIndex: "activity" },
      { title: t("constituency"), dataIndex: "constituency" },
      { title: t("buildingSegmented"), dataIndex: "buildingSegmented" },
      { title: t("ward"), dataIndex: "ward" },
      { title: t("subDivision1"), dataIndex: "subDivision1" },
      { title: t("subDivision2"), dataIndex: "subDivision2" },
    ];
  }, [t]);
  const tabList = useMemo(() => {
    return [
      { tab: t("buildInfo"), key: BUILDIN },
      { tab: t("lift"), key: "#LIFT" },
    ];
  }, [t]);
  return (
    <CustomDetailPage
      tabList={tabList}
      url="building"
      funcChildren={(key: string, data: any) => {
        return key === BUILDIN ? (
          <ProDescriptions
            dataSource={{ ...data.attribute, ...data }}
            className="bg-[#fff] dark:bg-[#141414] min-h-[calc(100vh-297px)] p-4"
            bordered
            columns={columns}
          />
        ) : (
          <BasicTable
            isShowCheckbox={false}
            tableColsRender={[...LiftColumns()]}
            tableName="lift"
            editTableHeaderUrl={BUILDING_LIFT_TABLE_HEADER}
            headerTitle={() => t("liftList")}
            className="min-h-[calc(100vh-297px)]"
            exportUrl={`/api/building/${data?.id}/lift/export`}
            requestUrl={`/api/building/${data?.id}/lift/page`}
          />
        );
      }}
      headerCongif={(_: string, data: any) => ({
        title: <span className="text-[20px] font-medium">{data?.name}</span>,
        children: (
          <div className="mb-5">
            <span className="mr-20">
              {t("address")}: {data?.attribute?.address}
            </span>
            <span className="mr-20">
              {t("esManagCompany")}: {data?.attribute?.estateMgmtCo}
            </span>
            <span className="mr-20">
              {t("branchOffice")}: {data?.attribute?.branchOffice}
            </span>
          </div>
        ),
        breadcrumb: {
          items: [
            { title: <Link to={PageEnum.BUILDING}>{t("building")}</Link> },
            { title: t("detail") },
          ],
        },
      })}
    />
  );
}
